import { useMemo } from "react";
import { useParams } from "@tanstack/react-router";

import { MOCK_CONSTRUCTOR_SERVICES, type ConstructorService } from "../../constructor-services-page/constructor-services-page.lib";

/** Услуга по id из роута; undefined — услуга не существует (страница уводит на /admin). */
export const useServiceDetail = (): { id: string | undefined; service: ConstructorService | undefined } => {
  const { id } = useParams({ strict: false });
  const service = useMemo(() => MOCK_CONSTRUCTOR_SERVICES.find((item) => item.id === id), [id]);

  return { id, service };
};
